module.exports = __webpack_public_path__ + "374df2a818582454b6e6832804e52f86.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/lato/lato-bold-webfont.woff
 ** module id = ./src/styles/fonts/lato/lato-bold-webfont.woff
 ** module chunks = 0
 **/